import {Importer} from "../../../../context/wineContext/reducer";
import React from "react";
import Link from "next/link";
import Image from "next/image";

const WineImportersList = ({importers}: { importers: Importer[] }) => {
  const importersSorted = importers.sort((a, b) => {
    let aName = a.name.toLowerCase();
    let bName = b.name.toLowerCase();
    if (aName < bName) {
      return -1;
    } else if (aName > bName) {
      return 1;
    } else {
      return 0;
    }
  });
  return (
    <div className="space-y-2">
      {importersSorted.map((importer, i) => (
        <div key={i} className="p-4 bg-gray-100 rounded flex flex-col space-y-2 md:space-y-0 md:flex-row">
          <Link href={`/importers/` + importer.slug}>
            <div className="w-full md:mr-4 pr-4 space-y-1 lg:space-y-0 cursor-pointer">
              <div className="block">
                <div className="font-bold text-xl text-center overflow-auto">
                  <span className="text-red">{importer.name}</span>
                </div>
              </div>
              {!importer.image_url.includes('missing.png') && !importer.image_url.toLowerCase().includes('blank_square.png') ? (
                <div className="aspect-square bg-cover bg-center hover relative overflow-hidden max-h-24 max-w-24 h-full w-full">
                  <Image
                    src={importer.image_url}
                    alt={`${importer.name} logo`}
                    fill
                    style={{objectFit: "contain"}}
                    sizes="(min-width: 640px) 50vw, 100vw"
                  />
                </div>
              ) : null
              }
            </div>
          </Link>

          <div className="w-full self-center">
            {importer.regional_info || importer.country ? (
              <p className="pb-2">Imports to: <span
                className="font-light">{importer.regional_info ? importer.regional_info : importer.country}</span></p>
            ) : null}
            {importer.address ? (
              <p className="pb-2">
                Address: <span className="font-light">{importer.address}</span>
              </p>
            ) : null}
            {importer.telephone ? (
              <p className="pb-2">
                Phone: <span className="font-light">{importer.telephone}</span>
              </p>
            ) : null}
            {importer.email ? (
              <p className="pb-2">
                Email: <span className="font-light">{importer.email}</span>
              </p>
            ) : null}
            {importer.website ? (
              <p className="pb-2">
                Website: <a className="font-light text-red" target="_blank" rel="noreferrer"
                            href={importer.website}>{importer.website}</a>
              </p>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  )
}

export default WineImportersList
